// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"1d971eef","453":"f8344d3b","548":"5eef88e7","779":"cefb5c11"}[chunkId] + ".chunk.js";
};